import { render, staticRenderFns } from "./oom.vue?vue&type=template&id=5f017f57&scoped=true"
import script from "./oom.vue?vue&type=script&lang=js"
export * from "./oom.vue?vue&type=script&lang=js"
import style0 from "./oom.vue?vue&type=style&index=0&id=5f017f57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f017f57",
  null
  
)

export default component.exports